module.exports = __webpack_public_path__ + "static/media/manzo_05_thumb.5397bddc.png";